import { clsx, type ClassValue } from "clsx";

/**
 * Class joiner. Deliberately no tailwind-merge (saves ~8 KB gzip in the entry chunk): components
 * never pass two utilities for the same property — override by choosing a different variant/size.
 */
export function cn(...inputs: ClassValue[]) {
  return clsx(inputs);
}
